import { http as orderHttp } from './http'

export const getActiveOrders = userId => orderHttp.get('/user/activeOrders', { params: { userId } })

export const getMyOrders = params => orderHttp.get('/user/myOrders', { params })

export const getMyOrderReviews = params => orderHttp.get('/user/myOrderReviews', { params })

export const deleteMyOrder = (id, userId) => orderHttp.delete(`/user/myOrders/${id}`, { params: { userId } })

export const advanceOrder = (id, data) => orderHttp.post(`/user/activeOrders/${id}/advance`, data)

export const cancelActiveOrder = (id, data) => orderHttp.post(`/user/activeOrders/${id}/cancel`, data)

export const requestOrderArbitration = (id, data) => orderHttp.post(`/user/activeOrders/${id}/arbitration`, data)

export const submitOrderAlertReview = (id, data) => orderHttp.post(`/user/activeOrders/${id}/alertReview`, data)

export const getOrderFulfillmentLogs = (id, userId) => orderHttp.get(`/user/activeOrders/${id}/fulfillmentLogs`, { params: { userId } })

export const createOrderSdkChallenge = (id, data) => orderHttp.post(`/user/activeOrders/${id}/sdkChallenge`, data)

export const confirmSubcontractPartner = (id, data) => orderHttp.post(`/user/activeOrders/${id}/subcontract/confirm`, data)

export const rejectSubcontractPartner = (id, data) => orderHttp.post(`/user/activeOrders/${id}/subcontract/reject`, data)

export const requestSubcontractHandover = (id, data) => orderHttp.post(`/user/activeOrders/${id}/subcontract/handover/request`, data)

export const confirmSubcontractHandover = (id, data) => orderHttp.post(`/user/activeOrders/${id}/subcontract/handover/confirm`, data)

export const getSdkStageVerification = (id, userId) => orderHttp.get(`/user/sdkStageVerifications/${id}`, { params: { userId } })
